var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "max-w-category-image mx-_75 text-center min-w-0 w-full mt-3 md_mt-0 cursor-pointer text-black hover_text-brand transition-250 transition-color",
      attrs: { tabindex: "0", tag: "div", to: _vm.route }
    },
    [
      _c(
        "svg",
        {
          staticClass: "h-full w-full",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            viewBox: "0 0 148 148"
          }
        },
        [
          _c("path", {
            attrs: {
              fill: _vm.fill,
              d:
                "M74 148c40.87 0 74-33.13 74-74S114.87 0 74 0 0 33.13 0 74s33.13 74 74 74z"
            }
          }),
          _c("g", { attrs: { opacity: ".47" } }, [
            _c("path", {
              staticClass: "text-white fill-current",
              attrs: {
                d:
                  "M74 126c28.719 0 52-23.281 52-52s-23.281-52-52-52-52 23.281-52 52 23.281 52 52 52z"
              }
            })
          ]),
          _vm.shouldLoad
            ? _c("image", {
                staticClass: "opacity-100",
                attrs: {
                  width: "100%",
                  height: "100%",
                  "xlink:href": _vm.image
                }
              })
            : _vm._e()
        ]
      ),
      _c("div", { staticClass: "text-2xl md_text-xl mt-1" }, [
        _vm._v(_vm._s(_vm.text))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }